<div class="share-buttons">
  <div *ngIf="shareMobileFlag" class="share-mobile">
    <div class="share-mobile-btn" (click)="shareMobile()">
      <span class="mdi mdi-share-variant share-icon"></span>
    </div>
  </div>
  <div *ngIf="shareMobileFlag==false" class="share-web">
    <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u={{shareUrl}}">
      <span class="mdi mdi-facebook"></span>
    </a>
    <a target="_blank" href="https://twitter.com/intent/tweet?text={{item.title}} {{shareUrl}}">
      <span class="mdi mdi-twitter"></span>
    </a>
  </div>
</div>
